import { Component, OnInit, inject, DestroyRef, signal } from '@angular/core';
import { HttpParams } from '@angular/common/http';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { ApiService } from '../../../core/service/api-service/api-service';
import { FEDERATION_SLUG } from '../../../../main';

@Component({
  selector: 'app-federation-shell',
  standalone: false,
  template: `
    @switch (state()) {
      @case ('loading') {
        <div style="display:flex;align-items:center;justify-content:center;min-height:100vh;">
          Chargement...
        </div>
      }
      @case ('valid') { <router-outlet></router-outlet> }
      @case ('invalid') { <app-invalid-federation [slug]="federationSlug" /> }
      @case ('no-federation') { <app-no-federation /> }
      @case ('module-off') {
        <div class="flex items-center justify-center min-h-screen bg-gray-50 p-4">
          <div role="alert" class="bg-white rounded-2xl shadow-lg p-6 sm:p-8 w-full max-w-md text-center">
            <div class="flex items-center justify-center w-16 h-16 bg-amber-100 text-amber-600 rounded-full mx-auto mb-6 text-3xl">!</div>
            <h1 class="text-xl font-bold text-gray-800">Module non activé</h1>
            <p class="mt-2 text-sm text-gray-500">Ce module n'est pas activé pour votre fédération. Contactez l'administrateur de la plateforme.</p>
          </div>
        </div>
      }
    }
  `,
})
export class FederationShellComponent implements OnInit {
  private api = inject(ApiService);
  private destroyRef = inject(DestroyRef);

  state = signal<'loading' | 'valid' | 'invalid' | 'no-federation' | 'module-off'>('loading');
  federationSlug = FEDERATION_SLUG;

  ngOnInit(): void {
    if (!this.federationSlug) {
      this.state.set('no-federation');
      return;
    }

    const params = new HttpParams().set('slug', this.federationSlug);
    this.api
      .get('/api/federations/resolve', params)
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe({
        next: (res: any) => this.state.set(res?.module_enabled === false ? 'module-off' : 'valid'),
        error: () => this.state.set('invalid'),
      });
  }
}
